import React from 'react'
import { Upload, Icon, Tooltip, message, Modal, Button, Select } from "antd";
import PropTypes from "prop-types";
import { uploadEnclosure } from '../../axios';
import ImageView from '../ImageView';
import './index.less'
import { API_upload_file_jr } from '../../axios/config';
import { attachTitleTypeMap } from '../../axios/dictionaries';


class FileUpload extends React.Component{
    state = {
        fileList: [],
        titleModalVisible: false
    }
    set(list) {
        if (!list) return
        const fileList = Array.isArray(list) ? list : [list]
        fileList.forEach(e => {
            if (typeof e === 'string') return e
            e.url = e.attach_url || e.imageUrl
            e.id = e.attach_id || e.id
        })
        this.setState({ fileList })
    }
    get() {
        return this.state.fileList.map(e => {
            if (typeof e === 'string') return e
            e.url = e.attach_url || e.imageUrl
            e.id = e.attach_id || e.id
            return e
        })
    }
    
    handleUpload(type, fileData) { // --- 上传附件
        fileData.id = fileData.attach_id
        fileData.url = fileData.attach_url
        this.setState(state => {
            state.fileList.push(fileData)
            return state
        })
        
    }

    handleFileDelete = (index) => { // --- 附件 --> 根据fileMap 的索引 删除
        this.setState(state => {
            state.fileList.splice(index,1)
            return state
        })
    }
    createFileView = (file, index) => { // --- 附件 --> 根据src 返回 图片还是其它
        if(!file) {
            return 
        }
        const src = typeof file === 'string' ? file : file.url 
        if (!src) {
            console.log('file', file)

        }
        const imgfilter = ['.png', '.jpg', '.gif', '.jpeg']
        let isImg = false
        imgfilter.forEach((e) => {
            if(src.indexOf(e) > -1){
                isImg = true
            }
        })
        if(isImg) {
            return <ImageView showPreview showDelete onDelete={this.handleFileDelete.bind(this,index)} src={src} mode="aspectFit" style={{width:120, height:120, border: '1px solid #eee'}} />
        }
        return (
            <div className="upload-box file" style={{margin:0}}>
                <Icon type="paper-clip" />
                <div className="mask">
                    <a href={src} target="_blank">
                        <Icon type="eye" />
                    </a>
                    <Icon type="delete" onClick={this.handleFileDelete.bind(this,index)} />
                </div>
            </div>
        )
    }
    renderConfirmTitleModal() { // --- 渲染 填入title 字段的弹窗
        const cancel = () => {
            this.setState({titleModalVisible: false})
        }
        const uploadBtnStyle = {
            width: 60,
            height: 60,
            marginRight: 10,
            border: '1px solid #eee',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
        }
        return (
            <Modal 
                title="请选择上传类型"
                visible={this.state.titleModalVisible}
                onCancel={cancel}
                footer={<Button type="primary" onClick={cancel}>取消</Button> }
            >
                <div style={{display: 'felx', flexWrap: 'wrap', justifyContent: 'space-between', padding: 24}}>

                    { attachTitleTypeMap.map(e => {
                        const dom = <div key={e.value} style={uploadBtnStyle} onClick={ cancel}>{e.title}</div>
                        const data = { title: e.value }
                        return this.renderUploadWrap(dom, data)
                    }) }
                </div>
          
            </Modal>
        )
    }
    renderUploadWrap (childern, data = {}) {
        const uploadConfig = uploadEnclosure({
            accept: '*',
            action: API_upload_file_jr,
            success: this.handleUpload.bind(this), 
            attachType: this.props.attachType, 
            data
        })
        return (
            <Upload {...uploadConfig}>
                {childern }
            </Upload>  
        )
    }
    renderActionBtn() {
        if (this.props.hasTitle ) {
            return (
                <div className="upload-box" onClick={() => this.setState({ titleModalVisible: true })}>
                    <Icon type="plus" />
                </div>
            )
        }
       
        return this.renderUploadWrap(<div className="upload-box"><Icon type="plus" /></div>)
    }
    render(){
      
        return (
            <div style={{display: 'flex', 'flexWrap': 'wrap'}}>
                {
                    this.state.fileList.length < (this.props.count || 1) &&
                    this.renderActionBtn()
                }
                {
                    this.state.fileList.map((e,i) => (
                        <div className="file-item" key={'file-' + i}>
                            <div className="value">
                                <div className="img-wrap" key={'file-' + i } >
                                    {this.createFileView(e, i)}
                                    {
                                        e && e.attach_name &&
                                        <Tooltip title={e.attach_name} >
                                            <div className="filename">{e.attach_name}</div>
                                        </Tooltip>
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }
                {this.props.hasTitle && this.renderConfirmTitleModal()}
            </div>
        )
    }
}
FileUpload.propTypes = {
    count: PropTypes.number,
    hasTitle: PropTypes.bool,
    attachType: PropTypes.number.isRequired,
};
export default FileUpload


// WEBPACK FOOTER //
// ./src/components/FileUpload_JR/index.js